import { useMemo } from "react";
import useSWR, { ConfigInterface } from "swr";
import { getSgApiService } from "../../../../sg-core";
import { useAuthentication } from "../../auth/store/authSelectors";
import { IObservationPackage, validateObservationPackage } from "../../interfaces/ObservationPackage/ObservationPackage";
import { getObservationService } from "../../services/observationService";
import * as Endpoint from "../../../endpoints";

type TData = IObservationPackage | null;

export type IUseHistoryPackageHook = (packageId: string | null, config?: ConfigInterface<TData>) => {
    data: TData;
    fetching: boolean;
};

export const useHistoryPackage: IUseHistoryPackageHook = (packageId, config) => {
    const { token, anonymousSession } = useAuthentication();

    const apiService = getSgApiService("");
    apiService.setToken(token || "");
    const observationService = getObservationService(apiService, Endpoint.havainnot, anonymousSession)


    const fetcher = async (): Promise<TData> => {
        if (!packageId) { return null }

        const packageResult = await observationService.getHistoryData(packageId);

        if (packageResult.isFailure) {
            throw packageResult.error
        };

        const permitPackage = validateObservationPackage(packageResult.value);
        if (!permitPackage.isSuccess) {
            throw permitPackage.error;
        };

        return permitPackage.value
    };

    const cacheKey = "obaservation:pacakge:" + packageId

    const { data, isValidating } = useSWR(
        cacheKey,
        fetcher,
        {
            suspense: true,
            revalidateOnFocus: false,
            revalidateOnMount: true,
            revalidateOnReconnect: false,
            ...config
        }
    );

    const rawData = data ?? null;

    return useMemo(() => ({
        data: rawData,
        fetching: isValidating,
    }), [rawData, isValidating]);
};
